import { Injectable } from '@angular/core';
import { UserHttpService } from 'src/providers/user-http.service';
import { forkJoin, Observable, of, tap } from 'rxjs';
import { UserContextService } from 'src/services/user-context.service';
import { RoutePermission } from 'src/app/core/models/route-permission-key';

@Injectable({ providedIn: 'root' })
export class OneTimeAlertService {
    constructor(private userHttpService: UserHttpService,
                private userContextService: UserContextService) {
    }

    /**
     * Ask the backend to send an alert.  The backend will only create the alert if it has never been created
     * in the past for this account.  The front end uses local storage to be kind and avoid extra calls during
     * every login, but the backend really enforces the "one time alert"
     */
    sendOneTimeAlert(notificationType) {
        const sessionStorageKey = 'alert_' + notificationType + '_sent';
        if (!localStorage.getItem(sessionStorageKey)) {
            return this.userHttpService.createOneTimeAlert(notificationType).pipe(
                tap(() => {
                    localStorage.setItem(sessionStorageKey, 'true');
                })
            );
        } else {
            return of(null);
        }
    }

    sendAllOneTimeAlerts() : Observable<any> {
        const alertObservables = [];
        // Creates alert to add contact information (just once)
        if (this.userContextService.hasPermissionToVisitRoute(RoutePermission.dashboardContacts) &&
            this.userContextService.isInsuranceIndividualAccount()) {
            alertObservables.push(this.sendOneTimeAlert('add_contact_information'));
        }

        // Creates alert to add backup email if user does not already have one
        if (this.userContextService.isInsuranceIndividualAccount()
            && !this.userContextService.isSecuritiesIndividualAccount()
            && !this.userContextService.userContext.user.backupEmailAddress) {
            alertObservables.push(this.sendOneTimeAlert('add_backup_email_address'));
        }

        if (alertObservables.length > 0) {
            return forkJoin(alertObservables);
        } else {
            return of(null);
        }
    }
}
